// extracted by mini-css-extract-plugin
module.exports = {"root_reset":"plasmic_valentino_root_reset__DOIoK"};